/* global require */
export default {
  ar: require('./ar.json'),
  en: require('./en.json'),
  de: require('./de.json'),
  fr: require('./fr.json'),
  es: require('./es.json'),
  pt: require('./pt.json'),
  it: require('./it.json'),
  ru: require('./ru.json'),
  zh: require('./zh.json'),
};
